import { render, staticRenderFns } from "./TLDform.vue?vue&type=template&id=7f2b7f90&lang=pug&"
import script from "./TLDform.vue?vue&type=script&lang=js&"
export * from "./TLDform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports